import React, { useEffect } from "react";
import { Alert, Button, Card, Col, Modal, Row } from "react-bootstrap";
import Footer from "./common/Footer";
import ButtonComponent from "./common/ButtonComponent";
import TextInputComponent from "./common/TextInputComponent";
import { useAppDispatch } from "../hooks/hooks";
import {
  loginUser,
  updateElementValueInLoginReducer,
  useLoginReducer,
} from "../redux/slice/loginSlice";
import { NewAgencyRegPopup } from "./user/NewAgencyRegPopup";
import { ForgotYourPasswordPopup } from "./user/ForgotYourPasswordPopup";
import AlertMessage from "./common/AlertMessage";
import { TiWarning } from "react-icons/ti";
import { TwoFactorAuthenticationPopup } from "./user/TwoFactorAuthenticationPopup";
import { useSearchParams } from "react-router-dom";
import { getApplicationData, useCommonReducer } from "../redux/slice/commonSlice";
import OptionPopup from "./common/OptionsPopup";
import ReleaseNotePopup from "./common/ReleaseNotePopup";

interface LoginProps {}

export const Login: React.FC<LoginProps> = (props) => {
  const dispatch = useAppDispatch();
  const { username, password, incorrectCredentialError } = useLoginReducer();
  const [showagencyModal, setShowAgencyModal] = React.useState(false);
  const [showForgotPassword, setShowForgotPassword] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState<string>("");
  const loginReducer = useLoginReducer();
  const [showTwoFactorAuthenicationModal, setShowTwoFactorAuthenicationModal] =
    React.useState(false);
  const [searchParams] = useSearchParams();
  // PR 11027 Starts
  const [testSystemAlert, setTestSystemAlert] = React.useState(false);
  // PR 11027 Ends

  const commonReducer = useCommonReducer();
  const [showReleasePopup, setShowReleasePopup] = React.useState<{ version: string, show: boolean }>({ version: "", show: false });

  useEffect(() => {
    if (loginReducer.changePwMessage) {
      let message = "";
      if (loginReducer.changePwMessage === "success") {
        message = "Your password has been successfully changed. Please log in using your new password.";
      } else if (loginReducer.changePwMessage === "noAccount") {
        message =
          "Could not find an account matching for your password reset request. Please make a new request to change password.";
      } else if (loginReducer.changePwMessage === "noRequest") {
        message =
          "A password reset request is only valid for one-time use. Please make a new request to change password.";
      } else {
        message = "Failed to change the password.";
      }
      setAlertMessage(message);
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    }

    //PR 11027 Starts
    if (
      process.env.REACT_APP_PROFILE !== "PRODUCTION" &&
      (!sessionStorage.getItem("isConfirmedTestSystem") ||
        sessionStorage.getItem("isConfirmedTestSystem") === "false")
    ) {
      setTestSystemAlert(true);
      sessionStorage.setItem("isConfirmedTestSystem", "false");
    }

    //PR 11027 Ends
  }, [loginReducer.changePwMessage, dispatch]);

  const onClickForgotPassword = () => {
    setShowForgotPassword(true);
  };

  const handleValChange = (event: any) => {
    dispatch(
      updateElementValueInLoginReducer({
        elementName: event.target.name,
        value: event.target.value,
      })
    );
  };

  // PR 11027 Starts
  const confirm = () => {
    setTestSystemAlert(false);
    sessionStorage.setItem("isConfirmedTestSystem", "true");
  };
  // PR 11027 Ends


  useEffect(() => {
    const message = searchParams.get("logoutMessage");
    if(message!==null){
      if (message === "SessionTimeOut"){
        dispatch(
          updateElementValueInLoginReducer({
            elementName: "incorrectCredentialError",
            value: "Session time out. Please login again.",
          })
        );
      }else if (message === "TokenExpired"){
        dispatch(
          updateElementValueInLoginReducer({
            elementName: "incorrectCredentialError",
            value: "Token expired. Please login again.",
          })
        );
      }
    }
    dispatch(getApplicationData());
  },[])

  useEffect(()=>{
    return ()=>{
      dispatch(
        updateElementValueInLoginReducer({
          elementName: "incorrectCredentialError",
          value: "",
        })
      );
    }
  },[]);

  // const handleCloseConfirm = () => {
  //   setConfirmPopupData(false);
  // };

  const handleConfirm = () => {
    setShowReleasePopup({ version: "", show: false })
    window.location.reload();
    localStorage.setItem("applicationVersion", commonReducer.applicationData?.applicationVersion || "");
  };

  useEffect(()=>{
    const storedVersion = localStorage.getItem("applicationVersion");
    if (commonReducer.applicationData?.applicationVersion?.trim() && 
      (storedVersion == null || storedVersion !== commonReducer.applicationData.applicationVersion)
    ) {
      setShowReleasePopup({
        version: commonReducer.applicationData.applicationVersion,
        show: true,
      });
    }
  },[dispatch, commonReducer.applicationData]);


  const maintenanceNoteRaw = commonReducer.applicationData?.maintenanceNote;
  let maintenanceNote = null;

  if (maintenanceNoteRaw) {
    try {
      maintenanceNote =
        typeof maintenanceNoteRaw === "string"
          ? JSON.parse(maintenanceNoteRaw)
          : maintenanceNoteRaw;
    } catch (err) {
      console.error("Failed to parse maintenanceNote", err);
      maintenanceNote = null;
    }
  }

  const decodeBase64Emoji = (base64: string): string => {
    try {
      return decodeURIComponent(escape(window.atob(base64)));
    } catch (e) {
      return ""; 
    }
  };




  return (
    <>
      <div className="image-background">
        <main>
          <div className="center-body">
            <AlertMessage
              message={alertMessage}
              onClose={() => setAlertMessage("")}
              variant={
                alertMessage === "Your password has been successfully changed. Please log in using your new password." ? "success" : "danger"
              }
            />
            <Card>
              <Card.Body>
                <Row>
                  {commonReducer.applicationData?.maintenanceNote && (
                  <Col md={6} className="d-flex">
                    <Card.Body className="note-body">
                      
                      <div>
                        <div className="d-flex align-items-center mb-3">
                          <TiWarning size={28} className="text-danger me-2" />
                          <h5 className="mb-0 fw-bold text-dark">
                            {maintenanceNote.title}
                          </h5>
                        </div>
                         <hr />
                        <div>
                          {maintenanceNote.details.map((item: any, idx: number) => (
                            <p className="mb-2">
                              <strong>{decodeBase64Emoji(item.iconbase64)} {item.heading}:</strong> {item.description}
                            </p>
                          ))}
                        </div>
                        <p className="text-muted fst-italic mt-2">{maintenanceNote.closing}</p>
                      </div>
                    </Card.Body>
                  </Col>
                  )}
                  <Col md={"auto"}>
                    <div className="logo">
                      <a 
                        href="https://conscisys.com" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ cursor: 'pointer' }}
                      >
                        <img
                          alt="conscisys logo"
                          src={require("../assets/conscisys_logo.png")}
                        />
                      </a>
                    </div>
                    <div className="text-center">
                      <h3>
                        <img
                          src={require("../assets/logo.png")}
                          width="35"
                          height="35"
                          alt="Logo"
                        />
                        <b className="ps-2">Illinois Court Services</b>
                      </h3>
                    </div>
                    <hr />
                    <div className="mb-3 fw-bold">
                      <label>Username</label>
                      <TextInputComponent
                        type="text"
                        className="form-control"
                        placeholder="Enter username"
                        name="username"
                        value={username}
                        onChange={(e) => handleValChange(e)}
                      />
                    </div>
                    <div className="mb-3 fw-bold">
                      <label>Password</label>
                      <TextInputComponent
                        type="password"
                        className="form-control"
                        placeholder="Enter password"
                        name="password"
                        value={password}
                        onChange={(e) => handleValChange(e)}
                        onKeyDown={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                            event.stopPropagation();
                            dispatch(
                              loginUser({
                                username: username,
                                password: password,
                              })
                            );
                          }
                        }}
                      />
                      <label className="text-danger">
                        {incorrectCredentialError}
                      </label>
                    </div>
                    <div className="d-grid">
                      <ButtonComponent
                        onClick={() =>
                          dispatch(
                            loginUser({
                              username: username,
                              password: password,
                            })
                          )
                        }
                      >
                        Login
                      </ButtonComponent>
                    </div>

                    <p className="forgot-password text-center mt-3">
                      Forgot your{" "}
                      <a
                        href="#forgot-password"
                        role="button"
                        onClick={onClickForgotPassword}
                      >
                        password?
                      </a>
                    </p>
                    <p className="forgot-password text-center mt-3">
                      <a
                        href="#new-user"
                        role="button"
                        onClick={() => setShowAgencyModal(true)}
                      >
                        New Agency User Registration
                      </a>
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
          <ForgotYourPasswordPopup
            show={showForgotPassword}
            onHide={() => setShowForgotPassword(false)}
          />
        </main>
        <Footer />
      </div>
      <NewAgencyRegPopup
        show={showagencyModal}
        onHide={() => setShowAgencyModal(false)}
      />

      {/* PR 11027 Starts */}
      <Modal
        show={testSystemAlert}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <b>Test System Alert</b>
        </Modal.Header>
        <Modal.Body>
          {/* <Row>
          <Col className="text-center">
            <h1>
              <RiQuestionLine className="text-danger" />
            </h1>
          </Col>
        </Row> */}
          <Row>
            <Col className="text-center text-danger">
              <h1>
                <TiWarning />
              </h1>
            </Col>
          </Row>
          <Row>
            <Col className="text-center mt-2 text-danger">
              <label>
                <b>
                  Attention ! This is a Test System. For Production system,
                  please visit the Production site.
                </b>
              </label>
            </Col>
          </Row>
          <hr />
          <Row className="g-2">
            <Col>
              <Button
                variant="primary"
                onClick={() => confirm()}
                className="w-100"
              >
                Confirm
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <TwoFactorAuthenticationPopup
        show={showTwoFactorAuthenicationModal}
        onHide={() => setShowTwoFactorAuthenicationModal(false)}
      />

      <ReleaseNotePopup
        open={showReleasePopup.show}
        onSubmit={handleConfirm}
        version = {showReleasePopup.version}
        />
    </>
  );
};

export default Login;
